import { surveysSlice } from "./surveysSlice";
// import * as defaultActions from "../../../../../redux/_helpers";
import * as defaultActions from "../../../../../redux/_common";
import { get, post, put } from "../../../../../api/requester";
import { Dispatch } from "redux";
import { getErrorMessage } from "../../../../../redux/_helpers";
import { ISurvey, ISurveyAnswerTypes } from "./_interfaces";

const { actions } = surveysSlice;
const moduleUrl = '/api/activity/surveys'

const callTypes = {
  surveyAnswerTypes: "surveyAnswerTypesLoading",
  surveyAnswerSubTypes: "surveyAnswerSubTypesLoading",

  surveyArticlesLoading: 'surveyArticlesLoading',

  surveyDynamicOperators: "surveyDynamicOperatorsLoading",
  taskTypes: "surveyTaskTypesLoading",
  action: "actionsLoading",
};

export const setValidationErrors = actions.setValidationErrors;



export const saveItem = (item:ISurvey, id: string | null) => async (dispatch:Dispatch) => {
  try {
    dispatch(actions.startItemCall({ callType: "actionsLoading" }));

    const formData = {
      surveyIdentifier: item.surveyIdentifier,
      id: item.id,
      version: 1,
      languageId: item.languageId,
      description: item.description,
      validFromUTC: item.validFromUTC,
      validToUTC: item.validToUTC,
      timeZone: null,
      enableCopyLast: item.enableCopyLast,
      isDefault: item.isDefault,
      isScoring: item.isScoring,
      isSuppressed: item.isSuppressed,
      sections: item.sections.map(section => ({
        questions: section.questions.map(question => ({
          surveyDynamicQuestionsDependencies: question.surveyDynamicQuestionsDependencies?.map(dependency => ({
            surveyConditionalQuestionId: dependency.surveyConditionalQuestionId,
            surveyDependantQuestionId: dependency.surveyDependantQuestionId,
            surveyDependantAnswerValueId: dependency.surveyDependantAnswerValueId,
            surveyDynamicOperatorId: dependency.surveyDynamicOperatorId,
            value: dependency.value,
          })),
          id: question.id,
          surveyAnswerTypeId: question.surveyAnswerTypeId,
          surveyAnswerSubTypeId: question.surveyAnswerSubTypeId,
          surveySectionId: section.surveyHeaderId,
          surveyQuestionIdentifier: question.surveyQuestionIdentifier,
          description: question.description,
          defaultValue: question.defaultValue !== "" ? question.defaultValue : null,
          isRequired: question.isRequired,
          min: question.min,
          max: question.max,
          isReadOnly: question.isReadOnly,
          sequence: question.sequence,
          copyLastEnabled: question.copyLastEnabled,
          score: question.score,
          isDynamic: question.isDynamic,
          enableAttachment: question.enableAttachment,
          requireAttachment: question.requireAttachment,
          surveyAnswerValues: Array.isArray(question.surveyAnswerValues)
            ? question.surveyAnswerValues?.map((answerValue) => ({
                id: answerValue.id,
                surveyQuestionId: answerValue.surveyQuestionId,
                value: answerValue.value,
                weight: answerValue.weight,
                order: answerValue.order,
                isSelected: answerValue.isSelected,
                articleId: answerValue.articleId?.id
              }))
            : question.surveyAnswerValues,
        })),
        id: section.id,
        surveyHeaderId: section.surveyHeaderId,
        parentId: section.parentId,
        sequence: section.sequence,
        surveySectionIdentifier: section.surveySectionIdentifier,
        description: section.description,
        surveySectionTypeId: section.surveySectionTypeId,
      })),
      taskTypes: item.taskTypes?.map(taskType => ({
        id: taskType.id,
        surveyId: taskType.surveyId,
        taskTypeId: taskType.taskTypeId,
        isMandatory: taskType.isMandatory,
      })),
    };
    const res = await post(moduleUrl, {}, formData);

    dispatch(actions.endActionCall());
    return res;
  } catch (errors) {
    dispatch(actions.catchError({
      errors: getErrorMessage(errors, "Can't save item"),//constructErrors(errors),
      callType: "actionsLoading", errorProp: "error"
    }));
    dispatch(actions.endActionCall());
  }
}
  



export const getItemForEdit = (id: string) => defaultActions.getItem(`${moduleUrl}/${id}`, actions);
export const getItems = (params: {}) => defaultActions.getItems(moduleUrl, actions, params);
export const deleteItem = (id: string) => defaultActions.deleteItem(`${moduleUrl}/${id}`, actions);

export const clearItem = () => defaultActions.clearItem(actions);
export const clear = () => defaultActions.clearAll(actions);
export const clearError = () => defaultActions.clearErrors(actions);

export const updateItem = (item: {}) => async (dispatch:Dispatch) => {
  try {
    dispatch(actions.startItemCall({ callType: "actionsLoading" }));
    const result = await put(moduleUrl, {}, item)
    dispatch(setItemForEdit(result));
    dispatch(actions.endActionCall());
    return result;
  } catch (errors) {
    dispatch(actions.catchError({
      errors: getErrorMessage(errors, "Can't update item"),//constructErrors(errors),
      callType: "actionsLoading", errorProp: "error"
    }));
    dispatch(actions.endActionCall());
  }
}

export const getSurveyDynamicOperators = () => async (dispatch:Dispatch) => {
  try {
    dispatch(actions.surveyDynamicOperatorsLoading(true));
    const res = await get('/api/activity/surveyQuestions/dynamicOperators');
    dispatch(actions.surveyDynamicOperators(res));

  } catch (errors) {
    dispatch(actions.catchError({
        errors: getErrorMessage(errors, "Can't load question for edit"),//constructErrors(errors),
        callType: "actionsLoading", errorProp: "error"
    }));
  } finally {
    dispatch(actions.surveyDynamicOperatorsLoading(false));
  }
};

export const getTaskTypes = () => async (dispatch:Dispatch) => {
  try {
    dispatch(actions.setTaskTypesLoading(true));
    const res = await get(`${moduleUrl}/taskTypes/taskTypesList`);
    dispatch(actions.setTaskTypes(res));
  } catch (errors) {
    dispatch(actions.catchError({
        errors: getErrorMessage(errors, "Can't load survey task types"),//constructErrors(errors),
        callType: "actionsLoading", errorProp: "error"
    }));
  } finally {
    dispatch(actions.setTaskTypesLoading(false))
  }
};

export const getSurveyAnswerTypes = () => async (dispatch:Dispatch) => {
  try {
    dispatch(actions.surveyAnswerTypesFetchedLoading(true));
    const res = await get('/api/activity/surveyQuestions/answerTypes');
    dispatch(actions.surveyAnswerTypesFetched(res));
  } catch (errors) {
    dispatch(actions.catchError({
      errors: getErrorMessage(errors, "Can't load survey task types"),//constructErrors(errors),
      callType: "actionsLoading", errorProp: "error"
    }));
  } finally {
    dispatch(actions.surveyAnswerTypesFetchedLoading(false));
  }
};

export const getSurveyAnswerSubTypes = (params:{AnswerTypeId:string}) => async (dispatch:Dispatch) => {
  try {
    dispatch(actions.surveyAnswerSubTypesFetchedLoading(true));
    const res = await get('/api/activity/surveyQuestions/answerSubTypes/select', params);
    dispatch(actions.surveyAnswerSubTypesFetched(res));
  } catch (errors) {
    dispatch(actions.catchError({
      errors: getErrorMessage(errors, "Can't load survey task sub-types"),//constructErrors(errors),
      callType: "actionsLoading", errorProp: "error"
    }));
  } finally {
    dispatch(actions.surveyAnswerSubTypesFetchedLoading(false));
  }
}

export const getSurveyVersions = (id:string) => async (dispatch:Dispatch) => {
  try {
    const res = await get(`${moduleUrl}/versions/${id}`);
    dispatch(actions.surveysVersions(res));
  } catch (errors) {
    dispatch(actions.catchError({
      errors: getErrorMessage(errors, "Can't load survey versions"),//constructErrors(errors),
      callType: "actionsLoading", errorProp: "error"
    }));
  }
};

export const getSurveyArticlesList = (query:{filter: string, qIndex: number}) => async (dispatch:Dispatch) => {
  try {
    dispatch(actions.surveyArticlesLoading({qIndex: query.qIndex, value: true}));
    const res = await get(`/api/appmasterdata/articles/articlesSearchList`, { Filter: query.filter });
    dispatch(actions.surveyArticlesFetched({ qIndex: query.qIndex, list: res }));
  } catch (errors) {
    dispatch(actions.catchError({
      errors: getErrorMessage(errors, "Can't load articles"),//constructErrors(errors),
      callType: "actionsLoading", errorProp: "error"
    }));
  } finally {
    dispatch(actions.surveyArticlesLoading({qIndex: query.qIndex, value: false}));
  }
}

export const setItemForEdit = (item:any) => actions.setItem(item)